module.exports = __webpack_public_path__ + "static/defile-7ea0ee68d7288a36839ce696aa9e3383.gif";